// Base class for custom API errors to reduce boilerplate
class ApiError extends Error {
    constructor(message: string) {
        super(message);
        this.name = this.constructor.name;
    }
}

export class UserProfileFetchError extends ApiError { }

export class AppInstallationInfoUpdateError extends ApiError { }